import { render, staticRenderFns } from "./passenger.vue?vue&type=template&id=638ccb4e&scoped=true"
import script from "./passenger.vue?vue&type=script&lang=js"
export * from "./passenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ccb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638ccb4e')) {
      api.createRecord('638ccb4e', component.options)
    } else {
      api.reload('638ccb4e', component.options)
    }
    module.hot.accept("./passenger.vue?vue&type=template&id=638ccb4e&scoped=true", function () {
      api.rerender('638ccb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/components/passenger.vue"
export default component.exports